var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "661px",
    height: "992px",
    viewBox: "0 0 661 992",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@0.5xLogoEy Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LogoEy-Copy",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.625522,4.85162384 C574.305466,-3.06347991 548.84403,-1.23904425 526.849132,9.92309627 C504.854234,21.0852368 488.129973,40.6695234 480.359893,64.3624892 L215.784724,868.038752 C207.988102,891.713499 209.77349,917.564609 220.747909,939.902035 C231.722327,962.239461 250.986265,979.232328 274.299565,987.140363 L274.299565,987.140363 C297.609359,995.059054 323.061968,993.245713 345.055057,982.099472 C367.048145,970.953231 383.779064,951.387686 391.565194,927.709378 L656.219012,123.953235 C672.401235,74.6321755 646.17477,21.3222572 597.625522,4.85162384 Z",
    id: "Path",
    fill: "#FD5F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.214596,283.143085 L180.443019,64.2862948 C164.252751,15.0253023 111.806313,-11.5794465 63.3006191,4.862925 C14.7949255,21.3052965 -11.4019036,74.5683969 4.78836374,123.829389 L84.4813482,342.686179 C92.2628203,366.366057 108.990172,385.935546 130.981963,397.087693 C152.973754,408.23984 178.427653,410.060674 201.741637,402.149457 L201.741637,402.149457 C250.224707,385.658605 276.39216,332.401617 260.214596,283.143085 Z",
    id: "Path",
    fill: "#FDC355"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/logoBig.744512f5fec817242c9ed144a8301869.svg";
export { ForwardRef as ReactComponent };